import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './loader/loader.component';
import { MapsSearchComponent } from './maps-search/maps-search.component';
import { FormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { SplitPipe } from './pipes/split.pipe';

@NgModule({
  imports: [CommonModule, FormsModule, AgmCoreModule.forRoot({ apiKey: 'AIzaSyAs20OmCdNosCYqtATLQpv5e2upswcjyR8' })],
  declarations: [LoaderComponent, MapsSearchComponent, SplitPipe],
  exports: [LoaderComponent, MapsSearchComponent, SplitPipe],
})
export class CoreModule {}
